export default {"src":"/_next/static/media/linkedin.df2905ca.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};